import { ArrowLeft } from "lucide-react";
import logo from "../public/logo.png";

export function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      {/* Nav */}
      <nav className="flex items-center justify-between px-5 md:px-10 lg:px-16 py-5 border-b border-white/10">
        <a href="/">
          <img src={logo} alt="Empire Insurance" className="h-10 md:h-12" />
        </a>
        <a
          href="/"
          className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </a>
      </nav>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-12 md:py-20">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-2">Terms of Use</h1>
        <p className="text-gray-500 mb-10">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

        <div className="prose prose-invert prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-400 leading-relaxed">
              By accessing or using the Empire Insurance Agency website and services, you agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree to these terms, please do not use our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">2. Eligibility</h2>
            <p className="text-gray-400 leading-relaxed">
              You must be at least 18 years old to use our website and apply for positions. By submitting an application, you represent that you are at least 18 years of age and have the legal capacity to enter into binding agreements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">3. Application Process</h2>
            <p className="text-gray-400 leading-relaxed mb-4">By submitting an application through our website, you agree that:</p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>All information provided is accurate, complete, and truthful</li>
              <li>You authorize us to verify the information you provide</li>
              <li>Submitting an application does not guarantee employment</li>
              <li>We may contact you via phone, email, or text regarding your application</li>
              <li>You meet the eligibility requirements for the position</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">4. No Employment Guarantee</h2>
            <p className="text-gray-400 leading-relaxed">
              Nothing on this website constitutes a guarantee of employment or income. All positions are subject to our hiring process, background verification, and licensing requirements. Income examples and testimonials represent individual results and are not guarantees of future performance. Your results may vary based on your effort, skills, market conditions, and other factors.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">5. Commission-Based Compensation</h2>
            <p className="text-gray-400 leading-relaxed">
              Positions offered through this website are commission-based. This means compensation is directly tied to sales performance. There is no guaranteed base salary. You acknowledge that you understand and accept this compensation structure before applying.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">6. Licensing Requirements</h2>
            <p className="text-gray-400 leading-relaxed">
              Insurance sales positions require appropriate state licensing. You are responsible for obtaining and maintaining any required licenses. We may provide guidance and resources, but the responsibility for licensing compliance remains with you.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">7. Intellectual Property</h2>
            <p className="text-gray-400 leading-relaxed">
              All content on this website, including text, graphics, logos, images, and software, is the property of Empire Insurance Agency or its licensors and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">8. Prohibited Conduct</h2>
            <p className="text-gray-400 leading-relaxed mb-4">You agree not to:</p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Provide false or misleading information</li>
              <li>Use the website for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of the website</li>
              <li>Scrape or collect data from the website without permission</li>
              <li>Impersonate any person or entity</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">9. Disclaimer of Warranties</h2>
            <p className="text-gray-400 leading-relaxed">
              THIS WEBSITE AND ALL CONTENT ARE PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">10. Limitation of Liability</h2>
            <p className="text-gray-400 leading-relaxed">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, EMPIRE INSURANCE AGENCY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE WEBSITE OR SERVICES, REGARDLESS OF THE CAUSE OF ACTION.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">11. Indemnification</h2>
            <p className="text-gray-400 leading-relaxed">
              You agree to indemnify and hold harmless Empire Insurance Agency, its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of the website or violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">12. Governing Law</h2>
            <p className="text-gray-400 leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Florida.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">13. Changes to Terms</h2>
            <p className="text-gray-400 leading-relaxed">
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">14. Contact Information</h2>
            <p className="text-gray-400 leading-relaxed">
              For questions about these Terms of Use, please contact us at:
            </p>
            <p className="text-gray-400 mt-4">
              <strong className="text-white">Empire Insurance Agency</strong><br />
              South Florida<br />
              Email: admin@getempire.io
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="px-5 md:px-10 lg:px-16 py-8 border-t border-white/10">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Empire Insurance Agency. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Terms;
